
<div class="bi-spreadsheet">
  <div class="bi-spreadsheet-delete">
    <i class="far fa-trash-alt cursor-pointer so-remove" v-on:click="removeSpreadsheet()"></i>
  </div>

  <spreadsheet v-on:change="updateState" ref="spreadsheet" :sheetsbar="false" :toolbar="{home: ['bold', 'italic', 'underline', 'backgroundColor', 'alignment', 'merge'], insert:false, data: false}" >
    <spreadsheet-sheet :name="sheetName" />
  </spreadsheet>
</div>
